// extracted by mini-css-extract-plugin
module.exports = {"name_wrapper":"a10a3f92e9--name_wrapper--cmpLg","name":"a10a3f92e9--name--jciiJ","honest_brand":"a10a3f92e9--honest_brand--GYB6F"};